import { Badge, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui';
import { IHasEmployee } from '@/interfaces';
import { Info } from 'lucide-react';

export const BadgePermissionsCount = ({ employee }: IHasEmployee) => (
  <div className='my-auto flex items-center space-x-2'>
    {
      employee?.roles?.root
        ? <Badge className='bg-red-500'>
          ROOT
        </Badge >
        : <Badge className='bg-purple-600'>
          {employee?.roles?.permissions?.length ?? 0}
        </Badge>
    }
    <TooltipProvider delayDuration={500}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info size={16} />
        </TooltipTrigger>
        <TooltipContent side='right' align='start'>
          <ul className='list-disc ps-4 pe-2'>
            {
              employee
                ?.roles
                ?.permissions
                ?.map(l => <li key={l}>{l}</li>)
            }
          </ul>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </div>
);

export default BadgePermissionsCount;
